












import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import SupportTicketInjectorMixin from "@/mixins/supportTicketInjectorMixin";

@Component({
  components: {
    "client-ticket-actions": () =>
      import("@/components/app/client/support/clientTicketActions.vue"),
    "client-ticket-details-list": () =>
      import("@/components/app/client/support/clientTicketDetailsList.vue")
  }
})
export default class ClientTicketDetailsComponent extends Mixins(
  SupportTicketInjectorMixin
) {
  // Props
  @Prop({
    required: true,
    validator: tag => ["u-aside", "u-section-box"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    return !_.isNull(this.ticketData.ticket);
  }
}
